<template>
    <div class="item" @click="goTeamDetail($route.query,itemData.teamId, $route.query, pageBtnStatusDto.btnInnerStatus)">
        <img :src="itemData.imgUrl" />
        <span class="right-box">
            <h4 class="team-name nowrap" :title="itemData.teamName">
                {{ itemData.teamName }}
            </h4>
            <span class="leader nowrap">
                {{$t('planLxDetail.DZ')}}：{{ itemData.leaderName }}
            </span>
            
            <el-progress 
                v-if="planDto.status == 1 && itemData.processStatus === 1"
                :stroke-width="10"
                :percentage="itemData.processDto.percent ? Number(itemData.processDto.percent) : 0"
                >
            </el-progress>
            <div v-else class="status-type nowrap" :class="{ 'success': itemData.createStatus == 1, 'ing': itemData.createStatus == 0 }">
                <span class="dian"></span>
                <span  
                    :title="itemData.createStatus == 1 ? 
                        itemData.processStatus == 2 ? 
                        $t('planLxDetail.YJJ') : 
                        $t('planLxDetail.YJX') :
                        $t('planLxDetail.ZJZ')">
                            {{ 
                                itemData.createStatus == 1 ? 
                                itemData.processStatus == 2 ? 
                                $t('planLxDetail.YJJ') : 
                                $t('planLxDetail.YJX') : 
                                $t('planLxDetail.ZJZ') 
                            }}
                </span>
            </div>
        </span>
    </div>
</template>
<script>
import main from '@/mins/main'
export default {
    name: 'listItem',
    mixins: [main],
    props: {
        itemData: {
            type: Object,
            default: ()=>({})
        },
        planDto: {
            type: Object,
            default: ()=>({})
        },
        pageBtnStatusDto: Object
    },
}
</script>
<style scoped lang="scss">
.item{
    width: 22%;
    margin: 0 1.5% 20px 1.5%;
    height: 120px;
    display: flex;
    box-sizing: border-box;
    padding: 16px;
    border: 1px solid #D5DAED;
    border-radius: 8px;
    > img{
        width: 88px;
        height: 88px;
    }
    .right-box{
        margin-left: 16px;
        width: calc(100% - 88px - 16px);
    }
    .team-name{
        font-size: 16px;
        font-family: Hiragino Sans GB;
        font-weight: normal;
        letter-spacing: 2px;
        color: #0D141E;
        margin: 6px 0;
    }
    .leader{
        font-size: 14px;
        font-family: Hiragino Sans GB;
        font-weight: normal;
        color: #5D646E;
        // margin: 6px 0;
        display: inline-block;
        width: 100%;
    }
    /deep/ .el-progress{
        .el-progress__text{
            @include fontstyle(12px, #5397F7, normal, 'Hiragino Sans GB')
        }
    }
}
.item:hover{
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.16);
    cursor: pointer;
}
.status-type{
    .dian{
        width: 8px;
        height: 8px;
        display: inline-block;
        border-radius: 50%;
        margin-right: 4px;
    }
    font-size: 14px;
    font-family: Hiragino Sans GB;
    font-weight: normal;
    // margin-top: 6px;
}
.success{
    .dian{
       background: #29CE42;
    }
    color: #29CE42;
}
.ing{
    .dian{
       background: #FFC130;
    }
    color: #FFC130;
}
</style>